module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"overMaximumFail":"選取失敗！最多只可選取張 {n} 圖片，請重新匯入或刪除現有圖片。"},"en":{"overMaximumFail":"You can choose only {n} images at most. Please try again or remove existing images"}}')
  delete Component.options._Ctor
}
